import { dynamicNestedData } from "../js/common.js";
import { UpdateCartItem } from "../js/common.js";

// ********************** Initializations **********************
// --
const navBarControl = document.getElementById("navBarControl");
const navBarToggler = document.getElementById("navBarToggler");
const navBarContent = document.getElementById("navBarContent");
const cartCounter = document.getElementById("cartCounter");
// --
const mainBackDrop = document.getElementById("mainBackDrop");
//--
const signatureDrinksControl = document.getElementById("signatureDrinksControl");
// --
const product_list = document.getElementById("product_list");
// --
const popup = document.getElementById("popup");
const closePopup = document.getElementById("closePopup");

// ********************** Functions **********************
// --
function LoadPage(){
  // --
  var sum = 0;
  
  // -- Initialize Counter
  cartCounter.innerHTML = '';

  // -- Cart Page
    dynamicNestedData.forEach(item => {
      // -- Change to if item is checked!!
      if(item.IsAdded == 1){
        // -- Process Selected item
        // alert(item.IsAdded);
  
        // -- Process Sum
        sum += item.CartCount;
      }
    });

  // -- Update Counter
  cartCounter.innerHTML = '<sup>' + sum + '</sup>';
}
// --
function LoadProductList(){
  product_list.innerHTML = '';

  // --
  dynamicNestedData.forEach(item => {
    // --
    const listItem = document.createElement('li');
    const linkItem = document.createElement('a');
    const product_container = document.createElement('div');
    const image_container = document.createElement('div');
    const product_content_container = document.createElement('div');
    const product_description_container = document.createElement('div');
    const product_description_container_desc = document.createElement('p');
    const product_description_container_price = document.createElement('p');
    const product_info_container = document.createElement('div');
    const product_info_linkItem = document.createElement('a');
    const product_info_linkItem_fontawesome = document.createElement('i');
    const product_info_button = document.createElement('button');
    const product_info_button_linkItem = document.createElement('a');
    const product_image = document.createElement('img');

    // --
    // --
    product_description_container_desc.innerHTML = item.Label;
    product_description_container_price.innerHTML = 'Price $' + item.Price;
    product_description_container.classList.add('productlisting_content_description');
    product_description_container.appendChild(product_description_container_desc);
    product_description_container.appendChild(product_description_container_price);

    // --
    // -- First
    product_info_button_linkItem.setAttribute('ID', item.ID + "_Cart");
    product_info_button_linkItem.classList.add('cart');
    product_info_button_linkItem.innerHTML = "Add to Cart";
    product_info_button_linkItem.setAttribute('href', './productDetail.html');
    product_info_button.classList.add('btn');
    product_info_button.classList.add('btn--productlisting');
    product_info_button.appendChild(product_info_button_linkItem);
    // -- Second
    product_info_linkItem_fontawesome.setAttribute('ID', item.ID);
    product_info_linkItem_fontawesome.classList.add('fa');
    product_info_linkItem_fontawesome.classList.add('fa-info-circle');
    product_info_linkItem_fontawesome.classList.add('facustom_information--item');
    product_info_linkItem.setAttribute('href', '');
    product_info_linkItem.setAttribute('target', '_blank');
    product_info_linkItem.appendChild(product_info_linkItem_fontawesome);
    // -- Container
    product_info_container.classList.add('productlisting_content_info');
    product_info_container.appendChild(product_info_linkItem);
    product_info_container.appendChild(product_info_button);
    // -- Parent Container (product section)
    product_content_container.classList.add('productlisting_content');
    product_content_container.appendChild(product_description_container);
    product_content_container.appendChild(product_info_container);
    
    // -- 
    product_image.src = item.ImgSrc;
    product_image.classList.add('productlisting--resize');

    // -- 
    image_container.classList.add('productlisting_content_image')
    image_container.appendChild(product_image);

    // --
    product_container.appendChild(image_container);
    product_container.appendChild(product_content_container);

    // --
    // linkItem.setAttribute('href', '');
    linkItem.setAttribute('ID', item.ID);
    //
    linkItem.classList.add('productlisting_content_link');
    //
    linkItem.appendChild(product_container);

    // --
    listItem.classList.add('productlisting_content_list');
    listItem.appendChild(linkItem);

    // -- Finally
    product_list.appendChild(listItem);
  });
}
//--
function CreatePopUp(id){
  dynamicNestedData.forEach(item =>{
    if(item.ID == id){
      // Testing
      // console.log(item);
      // alert(id);

      // -- ***** Populate pop up ***** --
      const parentContainer = document.createElement('div');
      const productContainer = document.createElement('div');
      const productEscape = document.createElement('span');
      const productInfoContainer = document.createElement('div');
      const productInfoHeader = document.createElement('h2');
      const productInfoContent = document.createElement('p');

      // -- 
      productInfoHeader.innerHTML = 'Product Information';
      productInfoContent.innerHTML = 'This is a detailed description of our amazing product: ' + item.ID;
      // productInfoContainer.classList.add('productlisting_content_description');
      productInfoContainer.appendChild(productInfoHeader);
      productInfoContainer.appendChild(productInfoContent);

      // --
      productEscape.innerHTML = '&times;';
      productEscape.setAttribute('ID', 'closePopup_' + item.ID);
      productEscape.classList.add('close');

      // --
      productContainer.classList.add('popup_content');
      productContainer.appendChild(productEscape);
      productContainer.appendChild(productInfoContainer);

      // --
      popup.appendChild(productContainer);

      // -- Open popups
      OpenSelectedPopups(popup.id);
    }
  })
}
// --
function AddToCart(id){
  // Update the object
  UpdateCart(id);

  //
  const itemId = encodeURIComponent(id);
  const redirectURL = './cartControl.html?itemId='+itemId;
  //
  window.open(redirectURL, "_self");
}
// -- Close all Popups
function CloseAllOpenPopups(){
  document.querySelectorAll('popup_content').forEach(popup => {
    popup.classList.remove('popup_active');
    popup.classList.add('popup_disable');
  })
};
// --
function OpenSelectedPopups(id){
  const popSelected = document.getElementById(id);
  const childPopSelected = popSelected.querySelector('.popup_content');

  // --
  childPopSelected.classList.remove('popup_disable');
  childPopSelected.classList.add('popup_active');
  popSelected.classList.add('popup_active');
};
// --
function UpdateCart(id){
  // Add to Cart
  UpdateCartItem(id, 'ADD');
}
// -----------------------------------------------------------------
// -- Initialize Display
LoadPage();
LoadProductList();
// -----------------------------------------------------------------

// ********************** Listeners **********************
// --
// -- Attach Listeners
product_list.addEventListener('click', (e) =>{
  e.preventDefault();
  if(e.target.classList.contains('fa')){
    CloseAllOpenPopups();
    CreatePopUp(e.target.id);
  }
  else if(e.target.classList.contains('cart')){
    AddToCart(e.target.id.replace("_Cart", ""));
  }
});
popup.addEventListener('click', (e) => {
  e.preventDefault();

  //
  const popup = document.getElementById(e.target.parentElement.parentElement.id);
  const childpopup = popup.querySelector('.popup_content');

  // --
  popup.classList.remove('popup_active');
  popup.classList.add('popup_disable');

  // --
  popup.removeChild(childpopup);
});
// -- Single Instance
navBarToggler.addEventListener('click', (e) => {
  e.preventDefault();
  navBarControl.classList.toggle("collapsible--expanded");
  signatureDrinksControl.classList.toggle("collapsingControl__content");
});

// -- Groups
const gridCollapsibles = document.querySelectorAll(".grid__body--items");
gridCollapsibles.forEach((item) =>
  item.addEventListener("click", function() {
      this.classList.toggle("grid__collapsible");
  })
);
const articleCollapsible = document.querySelectorAll(".article--context");
articleCollapsible.forEach((item) =>
  item.addEventListener("click", function () {
    this.classList.toggle("article__expanded");
  }) 
);